import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

const IconDocEnrolment: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconDocEnrolment" {...props}>
    <svg height="100%" width="32" viewBox="0 0 32 32" fill="currentColor">
      <path d="M0 2C0 .89543.895431 0 2 0h20c1.1046 0 2 .895431 2 2v3.01169C23.8343 5.00393 23.6676 5 23.5 5c-.5093 0-1.0101.03626-1.5.10633V2H2v28h20v-4.1063c.4899.07.9907.1063 1.5.1063.1676 0 .3343-.0039.5-.0117V30c0 1.1046-.8954 2-2 2H2c-1.104569 0-2-.8954-2-2V2z" />
      <path d="M13.2994 13c-.1576.6453-.2555 1.3141-.2877 2H6c-.55228 0-1-.4477-1-1s.44772-1 1-1h7.2994zM17.3343 7c-.7821.5683-1.4827 1.24191-2.0811 2H6c-.55228 0-1-.44772-1-1s.44772-1 1-1h11.3343zM5 20c0-.5523.44772-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H6c-.55228 0-1-.4477-1-1z" />
      <path
        fillRule="evenodd"
        d="M23.5 24c4.6944 0 8.5-3.8056 8.5-8.5S28.1944 7 23.5 7 15 10.8056 15 15.5s3.8056 8.5 8.5 8.5zm6.0414-11.4318l-8.4366 7.9093-4.6978-4.4042 1.9179-2.0457 2.7799 2.6062 6.5187-6.1113 1.9179 2.0457z"
        clipRule="evenodd"
      />
    </svg>
  </IconSVG>
)

export default IconDocEnrolment
